<app-reports
  title="Client Encounter Type Report"
  [filtersForm]="filtersForm"
  [reportsUrl]="reportsUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">
      <app-report-location-eligibility-status-option
        formControlName="eligibilityStatuses" />

      <app-report-client-option
        formControlName="clientIds"
        [clientFilters]="{ applicableToReferralClaims: true }" />

      <app-report-text-option
        formControlName="encounterType"
        type="text"
        label="Encounter Type" />

      <app-report-client-entity-type-option
        formControlName="clientEntityTypes" />

      <app-report-client-lead-option
        formControlName="assignedClientLeadsIds" />
    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-location-eligibility-status-option
      [options]="report.filters" />

    <app-report-applied-client-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations" />

    <app-report-applied-text-option
      [options]="report.filters"
      name="encounterType"
      label="Encounter Type" />

    <app-report-applied-client-entity-type-option
      [options]="report.filters" />

    <app-report-applied-client-lead-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations" />

  </ng-template>
</app-reports>
